import React from 'react';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_ORDER_HISTORY} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {NewFrontlineOrdersContent} from './NewFrontlineOrdersContent';
import reportPayload from './reportPayload';

export const NewFrontlineOrdersReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', 'New Frontline Orders')}
      description={tt(
        'description',
        'Orders from new Frontline Clients and Coaches this month.',
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={NewFrontlineOrdersContent}
    />
  );
};

export default withHOC(
  withTranslation('report.newFrontlineOrders'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_ORDER_HISTORY,
    popoverContentProps: {
      renderTitle: () =>
        withTranslation.ts('reportRecordTitle.orderHistory', 'Order History'),
    },
  }),
)(NewFrontlineOrdersReport);
